import { BiteLogHeartlandEvent } from './bite_log_heartland_event.js';

export function name(event: BiteLogHeartlandEvent): string {
  switch (event) {
    case BiteLogHeartlandEvent.None:
      return 'ok';
    case BiteLogHeartlandEvent.TerminalDisconnected:
      return 'terminal-disconnected';
    case BiteLogHeartlandEvent.UpdateIdleTextError:
      return 'update-idle-text-error';
    case BiteLogHeartlandEvent.RefundError:
      return 'refund-error';
    case BiteLogHeartlandEvent.AuthTransaction:
      return 'transaction-authorization';
    case BiteLogHeartlandEvent.AuthTransactionError:
      return 'transaction-authorization-error';
    case BiteLogHeartlandEvent.SaleTransaction:
      return 'transaction-sale';
    case BiteLogHeartlandEvent.SaleTransactionError:
      return 'transaction-sale-error';
    case BiteLogHeartlandEvent.BalanceInquiry:
      return 'balance-inquiry';
    case BiteLogHeartlandEvent.BalanceInquiryError:
      return 'balance-inquiry-error';
    case BiteLogHeartlandEvent.TerminalConnected:
      return 'terminal-connected';
    case BiteLogHeartlandEvent.TerminalInitFailed:
      return 'terminal-init-failed';
    case BiteLogHeartlandEvent.SetupDevice:
      return 'setup-device';
    case BiteLogHeartlandEvent.DeviceResetFailed:
      return 'device-reset-failed';
    case BiteLogHeartlandEvent.NativeTransaction:
      return 'native-transaction';
    case BiteLogHeartlandEvent.NativeTransactionError:
      return 'native-transaction-error';
    case BiteLogHeartlandEvent.TransactionLookup:
      return 'transaction-lookup';
    case BiteLogHeartlandEvent.TransactionLookupError:
      return 'transaction-lookup-error';
  }
}
